import validate from "/builds/coingroup/fishcoin/market-client/node_modules/nuxt/dist/pages/runtime/validate.js";
import _10_45required_45auth_45global from "/builds/coingroup/fishcoin/market-client/app-modules/auth/middlewares/10.required-auth.global.ts";
import _11_45claims_45guard_45global from "/builds/coingroup/fishcoin/market-client/app-modules/auth/middlewares/11.claims-guard.global.ts";
export const globalMiddleware = [
  validate,
  _10_45required_45auth_45global,
  _11_45claims_45guard_45global
]
export const namedMiddleware = {}